
/* functionality for the image hovers, description and table hide/show */
document.addEventListener("DOMContentLoaded", function(event) {
  // Get references to the image containers, active images, descriptions, tables, and button containers
  const imageContainers = document.querySelectorAll(".image-container");
  const activeImages = document.querySelectorAll(".active-image");
  const descriptions = document.querySelectorAll(".description-one-div, .description-two-div, .description-three-div, .description-four-div");
  const tables = document.querySelectorAll(".table-one, .table-two, .table-three, .table-four");
  const buttonContainers = document.querySelectorAll(".button-container");

  // Function to activate the active image
  function activateImage(container) {
    if (container) {
      activeImages.forEach(function(activeImage) {
        activeImage.classList.remove("active-image");
      });
      container.classList.add("active-image");
    }
  }

  // Function to show the description and table corresponding to the hovered/clicked image
  function showDescriptionAndTable(container) {
    if (container) {
      const index = Array.from(imageContainers).indexOf(container);
      descriptions.forEach(function(description) {
        description.style.display = "none";
      });
      tables.forEach(function(table) {
        table.style.display = "none";
      });
      buttonContainers.forEach(function(buttonContainer) {
        buttonContainer.style.display = "none";
      });
      descriptions[index].style.display = "block";
      tables[index].style.display = "block";
      buttonContainers[index].style.display = ""; // Remove display property to reset to default display value
    }
  }

  // Function to handle the hover and click events on an image container
  function handleHoverOrClick(event) {
    const container = event.currentTarget;
    activateImage(container);
    showDescriptionAndTable(container);
  }

  // Hide all descriptions, tables, and button containers initially except for the first one
  descriptions.forEach(function(description, index) {
    if (index !== 0) {
      description.style.display = "none";
    }
  });
  tables.forEach(function(table, index) {
    if (index !== 0) {
      table.style.display = "none";
    }
  });
  buttonContainers.forEach(function(buttonContainer, index) {
    if (index !== 0) {
      buttonContainer.style.display = "none";
    }
  });

  // Add a hover event listener to each image container
  imageContainers.forEach(function(imageContainer) {
    imageContainer.addEventListener("mouseover", handleHoverOrClick);
    imageContainer.addEventListener("click", handleHoverOrClick);
  });

  // Trigger a hover event on the first image container to show the initial state
  handleHoverOrClick({ currentTarget: imageContainers[0] });

});/* functionality for the image hovers, description and table hide/show */
document.addEventListener("DOMContentLoaded", function() {
  
      // Get the tooltip element
      var tooltip = document.querySelector("[tooltip]");

      // Get the button element and add a click event listener to it
      var button = tooltip.querySelector("span[flow='down']");
      button.addEventListener("click", function() {
        // Toggle the display property of the tooltip element
        if (tooltip.style.display === "block") {
          tooltip.style.display = "none";
        } else {
          tooltip.style.display = "block";
        }
      });
  
      // Hide the tooltip element when the button is clicked again
      button.addEventListener("click", function() {
        tooltip.style.display = "none";
      });

});


//JS for popups//


